import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useGetWishlistProductsQuery } from '../queries/__generated__/getWishlistProducts.generated';
import { useGetWishlistSuppliersQuery } from '../queries/__generated__/getWishlistSuppliers.generated';
import { currentContextAtom } from '../state';
import {
  canAccessWishlistAtom,
  wishlistItemsAtom,
  wishlistLoadingAtom,
  wishlistSupplierAtom,
} from './state';

export default function useWishlist(): void {
  const { roleAssignmentId, companyId } = useAtomValue(currentContextAtom);
  const canAccessWishlist = useAtomValue(canAccessWishlistAtom);
  const setWishlistItems = useSetAtom(wishlistItemsAtom);
  const setWishlistSuppliers = useSetAtom(wishlistSupplierAtom);
  const setWishlistLoading = useSetAtom(wishlistLoadingAtom);
  const queryVariables = {
    companyId: companyId!,
    role_assignment_id: roleAssignmentId!,
  };
  const skip = !roleAssignmentId || !companyId;

  const { data: productsData, loading: productsLoading } = useGetWishlistProductsQuery({
    variables: queryVariables,
    skip,
  });

  const { data: suppliersData, loading: suppliersLoading } = useGetWishlistSuppliersQuery({
    variables: queryVariables,
    skip,
  });

  useEffect(() => {
    if (!roleAssignmentId || !companyId) {
      return;
    }

    if (!canAccessWishlist) {
      setWishlistItems([]);
      setWishlistSuppliers([]);
      setWishlistLoading(false);

      return;
    }

    if (!productsLoading && !suppliersLoading) {
      setWishlistItems(productsData?.getWishlistProducts?.items ?? []);
      setWishlistSuppliers(suppliersData?.getWishlistSuppliers?.items ?? []);
      setWishlistLoading(false);
    }
  }, [roleAssignmentId, companyId, productsLoading, suppliersLoading, canAccessWishlist, productsData, suppliersData]);
}
